import { useEffect, useState } from 'react';

import { findCountryCodeFromQueryParams } from '@helpers/utils';
import LocalStorage from '../local-storage';

/**
 *
 * @param {function} checkShouldUpdateValueFromLocalStorage - For checking difference between value and localStorage
 * @param {any} defaultValue - default value
 * @param {boolean} enable - Allows you run the hook when it ready (async)
 * @param {string} key - localStorage key
 * @param {boolean} prefixCountryCodeFromParam - Add prefix countryCode from URL params
 * @param {function} updateValueFromLocalStorage - Allows you callback update value from localStorage or defaultValue
 * @param {any} value - dynamic value for trigger set value to localStorage
 */

const useManageLocalStorage = ({
  checkShouldUpdateValueFromLocalStorage,
  defaultValue,
  enable = true,
  key,
  prefixCountryCodeFromParam = false,
  updateValueFromLocalStorage,
  value
}) => {
  const [isReadyForSetItem, setIsReadyForSetItem] = useState(false);
  const stringifyValue = JSON.stringify(value);
  const stringifyDefaultValue = JSON.stringify(defaultValue);
  const countryCode = findCountryCodeFromQueryParams();
  const localStorageKey = prefixCountryCodeFromParam && countryCode ? `${countryCode}_${key}` : key;

  /**
   * Effect for getting initial localStorage value and return the update callback
   */
  useEffect(() => {
    if (!key || !enable) return;

    const localStorageValue = LocalStorage.getItem(localStorageKey);

    if (defaultValue && updateValueFromLocalStorage) {
      const isDifferent = checkShouldUpdateValueFromLocalStorage
        ? checkShouldUpdateValueFromLocalStorage(localStorageValue)
        : stringifyDefaultValue !== JSON.stringify(localStorageValue);

      const updatedValue = isDifferent ? localStorageValue : defaultValue;

      updateValueFromLocalStorage(updatedValue);
      setIsReadyForSetItem(true);
    }
  }, [enable]);

  /**
   * Effect for detect value changes and set back to localStorage value
   */
  useEffect(() => {
    if (!key || !enable || !isReadyForSetItem) return;

    const localStorageValue = LocalStorage.getItem(localStorageKey);

    if (stringifyValue !== JSON.stringify(localStorageValue)) {
      LocalStorage.setItem(localStorageKey, value);
    }
  }, [value, enable, isReadyForSetItem]);
};

export default useManageLocalStorage;



// WEBPACK FOOTER //
// ./helpers/hooks/use-manage-local-storage.js